<template>
  <base-card
    large
    class=""
    style="min-height: calc(-141px - 1rem + 100vh)"
  >
    <div class="d-flex justify-content-between align-items-end">
      <base-heading class="drafts-title mb-0">
        {{ $t('outreach.title') }}
      </base-heading>
      <div class="d-flex">
        <base-search
          v-model="search"
          icon-position="left"
          class="search-drafts"
        />
        <base-button
          class="px-3 mr-0 d-flex"
          nowrap
          small
          inverse
          style="margin-left: 16px !important;"
          @click="$store.dispatch('entries/newItem')"
        >
          <base-icon
            icon="white-plus"
            class="mr-2"
          />
          <base-text
            light
            size="s"
          >
            {{ $t('outreach.new') }}
          </base-text>
        </base-button>
      </div>
    </div>
    <hr class="div">
    <div class="row">
      <div class="col-lg-2 col-md-3 col-sm-3">
        <base-heading class="title">
          Your Edits
        </base-heading>
        <div
          v-for="(filterItem, index) in filters"
          :key="`filter-${index}`"
          :class="`filteritem ${index === currentFilter ? 'selected' : ''}`"
          @click="onFilterDrafts(index)"
        >
          {{ filterItem.name }}
        </div>
        <div
          class="title mt-3 cursor-pointer"
          @click="exploreEditsMain"
        >
          Explore Edits
        </div>
        <div
          v-for="(filterItem, index) in exploreFilters"
          :key="`filter-edit-${index}`"
          :class="`filteritem ${(index) === currentExploreFilter ? 'selected' : ''}`"
          @click="onExploreFilterDrafts(index)"
        >
          {{ filterItem.name }}
        </div>
      </div>
      <div class="col-lg-10 col-md-9 col-sm-9">
        <base-list
          :key="listkey"
          mode="pagination"
          :page-size="pageSize"
          :items="items"
          :count="count"
          :loading="loading"
          @pageChange="$emit('pageChange', $event)"
        >
          <template slot="loading">
            <base-skeleton
              v-for="n in 4"
              :key="n"
              :opacity="0 + (1 /n)"
            >
              <div class="d-flex align-items-center">
                <div
                  class="skeleton__item"
                  style="max-width: 246px; height: 200px; margin-right: 24px;"
                />
                <div class="w-100">
                  <div
                    class="skeleton__item"
                    style="max-width: 350px"
                  />
                  <div
                    class="skeleton__item"
                    style="max-width: 250px"
                  />
                </div>
              </div>
            </base-skeleton>
          </template>

          <template v-slot:nodata>
            <template v-if="search !== ''">
              <base-text
                slot="nodata"
                size="s"
                light
              >
                {{ $t('common.noResult') }} "{{ search }}"
              </base-text>
            </template>
            <template v-else>
              <empty
                title="No edits yet"
                style="min-height: calc(-273px - 1rem + 100vh);"
              >
                <a
                  href="#"
                  class="link-orange font-weight-bold"
                  @click.prevent="$store.dispatch('entries/newItem')"
                >{{ $t('outreach.addAction') }}</a> {{ $t('outreach.addActionSuffix') }}
              </empty>
            </template>
          </template>
          <template v-slot:default="{item}">
            <draft-cell
              :subject="item.subject"
              :owner-first-name="item.owner_first_name"
              :owner-last-name="item.owner_last_name"
              :background-image="item.hero || ''"
              :created="item.created_iso"
              :modified="item.modified"
              :identifier="item.pk"
              :status="item.display"
              :sent-date="item.sent_date"
              :is-mine="item.is_mine"
              :is-template="item.is_template"
              :likes-count="item.likes_count"
              :is-liked-by-me="item.is_liked_by_me"
              :pk="item.pk"
              :is-explore-edits-menu="currentExploreFilter >= 0"
              :current-explore-filter="currentExploreFilter"
              :sent-to="item.sent_to"
              @cloned="onCloned"
              @unschedule="onUnschedule(item)"
              @template-change="$emit('refresh')"
            />
          </template>
        </base-list>
      </div>
    </div>
  </base-card>
</template>

<script>
import { EventBus } from '@/event-bus';
import { entryService } from '@/_services';
import DraftCell from './Drafts/DraftCell';
import minHeightMixin from '../mixins/minheight';

export default {
  mixins: [minHeightMixin],
  component: {
    DraftCell,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      search: '',
      currentFilter: 0,
      currentExploreFilter: 0,
      listkey: Date.now(),
      has_edit_library: this.useFeature('has_edit_library'),
      has_template_library: this.useFeature('has_template_library'),
    };
  },
  computed: {
    filters() {
      const l = [{
        name: 'View All',
      }, {
        name: 'Drafts',
        sent: false,
      }, {
        name: 'Sent',
        sent: true,
      }];

      return l;
    },

    filter() {
      return this.filters[this.currentFilter];
    },

    exploreFilters() {
      const l = [];

      if (this.has_edit_library) {
        l.push({
          name: 'Library',
          sent: 'byteam',
        });
      }
      if (this.has_template_library) {
        l.push({
          name: 'Templates',
          sent: 'templates',
        });
      }
      return l;
    },

    exploreFilter() {
      return this.exploreFilters[this.currentExploreFilter];
    },
  },
  watch: {
    search(val) {
      this.$emit('search', val);
    },
    filter(newval) {
      if (newval) this.$emit('filter-changed', newval.sent);
    },
    exploreFilter(newval) {
      if (newval) this.$emit('filter-changed', newval.sent);
    },
  },
  mounted() {
    this.currentFilter = this.filters.map((f) => `${f.sent}`).indexOf(`${this.$route.query.filter}`);
    this.currentExploreFilter = this.exploreFilters.map((f) => `${f.sent}`).indexOf(`${this.$route.query.filter}`);
  },
  methods: {
    onCloned(editId) {
      // Go to the resulting edit
      this.$router.push(`/entries/${editId}/edit`);
    },
    onFilterDrafts(filterIndex) {
      this.currentExploreFilter = -1;
      this.currentFilter = filterIndex;
      this.listkey = Date.now();
    },
    onExploreFilterDrafts(filterIndex) {
      this.currentFilter = -1;
      this.currentExploreFilter = filterIndex;
      this.listkey = Date.now();
    },
    exploreEditsMain() {
      this.currentFilter = -1;
      this.currentExploreFilter = 0;
    },
    onUnschedule(edit) {
      entryService.patchItem({ url: edit.url, scheduled_process: null }).then((response) => {
        EventBus.$emit('confirm', {
          title: 'Done',
          message: 'Your scheduled send has been canceled and your edit has been saved as a draft.',
          showOptions: false,
          showCloseButton: true,
        });
        this.$emit('refresh');
      }).catch(() => {
        EventBus.$emit('toast-error', 'Couldn\'t cancel scheduled email, please try again in a few seconds.');
      });
    },
  },
};
</script>
<style lang="scss"
  scoped>
.drafts-title {
  letter-spacing: 0.56px;
  font-size: 1.25rem;
  font-family: 'Tiempos';
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 120%;
}
.title{
  font-size: 0.875rem;
  line-height: 1rem;
  font-family: $font-family-sans-serif-semibold;
  color: $dark-black;
  padding: 0 12px 6px 12px;
  margin-bottom: 5px;
}

::v-deep .base-search {
    margin-right: 0;
    height: 36px;
    box-shadow: unset !important;
    &__input {
      // font
      font-family: 'SilkaLight' !important;
      font-size: 14px;
      // design
      background-color: #FFF;
      border: 1px solid #C6C6C6;
      border-radius: 5px;
      font-family: $font-family-sans-serif-medium;
      max-width: 100%;
      max-height:36px;
    }
    ::placeholder {
      color: #909090;
    }
  }
::v-deep .base-search__icon--left {
  margin-left: 5px;
  height: 16px !important;
  width: 16px !important;
}

.filteritem {
  cursor: pointer;
  font-size: 14px;
  padding: 6px 12px 6px 20px;
  font-family: $font-family-sans-serif-light;
  transition: background-color .3s ease;
  margin-bottom: 4px;
  color: $dark-black;

  &:hover {
    background-color: $bg-admin;
  }

  &.selected {
    background-color: $bg-admin;
  }
}
::v-deep .skeleton__container {
  margin-bottom: 0;
}

@media (min-width: map-get($breakpoints,'lg')) {
  ::v-deep .mt-4 {
    margin-left: -20%;
  }
}
</style>
